"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { type FC, useEffect } from "react";

import { useAuthenticationStore } from "@/libs/store/accountStore/useAuthenticationStore";
import { useLoadingStore } from "@/libs/store/LoadingStore/useLoadingStore";

interface AuthenticationHandleParamsComponentProps {}

const AuthenticationHandleParamsComponent: FC<
  AuthenticationHandleParamsComponentProps
> = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const { setIsOpenErrorPopup, setErrorPopupMessage, setPropsErrorPopup } =
    useLoadingStore();
  const { setOpenLoginPopup } = useAuthenticationStore();

  useEffect(() => {
    const errorParams = searchParams.get("error");
    const openParams = searchParams.get("open");
    if (errorParams) {
      setIsOpenErrorPopup(true);
      setErrorPopupMessage({ refCode: errorParams });
      setPropsErrorPopup({
        handleOpen: () => {
          setIsOpenErrorPopup(false);
          router.replace(pathname);
        },
      });
      return;
    }
    if (openParams === "login") {
      setOpenLoginPopup(true);
    }
  }, [searchParams]);
  return "";
};

export default AuthenticationHandleParamsComponent;
